export class ClaimData {
  constructor() {
    this.persons = [];
    this.policies = [];
    this.categories = [];
    this.classes = [];
    this.eventTypes = [];
    this.vehicles = [];
    this.vehicleBenefits = [];

  }

  persons: any[];
  policies: any[];
  categories: any[];
  classes: any[];
  eventTypes: any[];
  vehicles: any[];
  vehicleBenefits: any[];
  selected_classes: any[];
}


export interface FlowQuestion {
  angular_component: string;
  cent_aq_question_id: any;
  question_copy: string;
  question_prompt: string;
  event_types: string;
  group_type: any;
  group_type_index: any;
  stage_name: string;
  stage_index: any;
  answer: string;
  cent_aq_question_type: string;
  options: any;
  conditions: any;
  vehicles: any;
  page: number;
  vehicle: any;
  next: number;
  question_hint: string;
  question_help: string;
  piped_question_id: string;
  parent_control: any;
  can_skip: any;
  question_image: any;
  call_proc: any;
  item_id: any;
  product_class_id: any;
}

export interface ClaimDetails {
  claim_id: number;
  person_id: number;
  policy_session_id: string;
  session_id: string;
  claim_name: string;
  claim_status: any;
  claim_date: any;
  last_question_id: any;
  current_question_id: any;
  claim_type_id: number;
  select_item_questions: any;
  current_collation_id: any;
  selected_vehicles: any[];
  selected_benefits: any[];
  selected_contents: any[];
  selected_classes: any[];
}

export class ClaimsLandingDetails {
  benefit_detail: string;
  benefit_details_parsed: ClaimLandingBenefitDetails[] = [];
  category_description: string;
  category_name: string;
  category_class: string;
  claim_date: string;
  claim_icon: string;
  currency: string;
  claim_id: number;
  claim_location: string;
  claim_location_parsed: ClaimLandingLocation;
  claim_location_details: string;
  claim_name: string;
  claim_notice: string;
  claim_notice_parsed: ClaimLandingNotice[] = [];
  claim_session_id: string;
  claim_status: string;
  claim_status_parsed: ClaimLandingStatus[] = [];
  estimate_value: any;
  item_detail: string;
  item_details_parsed: ClaimLandingItemDetails[] = [];
  emergency_detail: string;
  emergency_detail_parsed: ClaimLandingItemDetails[] = [];
  paid_value: any;
  policy_id: string;
  policy_session_id: string;
  product_category_id: number;
  product_code: string;
  product_description: string;
  product_id: number;
  version_id: number;
  claim_version_id: number;
  totalItemBenefitsLength = 0;
  isSeeMoreOpen = false;
}

export class ClaimLandingBenefitDetails {
  vaps_name: string;
  class_name: string;
  icon_path: string;
  description_1: string;
  estimate_value: number;
  paid_value: number;
  claim_status: ClaimLandingStatus[] = [];
}

export class ClaimLandingLocation {
  apartmentNo: string;
  complex: string;
  streetAddress: string;
  suburb: string;
  province: string;
  city: string;
  postalCode: string;
}

export class ClaimLandingNotice {
  icon: string;
  description: string;
}

export class ClaimLandingStatus {
  claim_status: string;
  icon_path: string;
  css_class: string;
}

export class ClaimLandingItemDetails {
  class_id: number;
  item_id: string;
  product_class: string;
  description_1: string;
  description_1_details_1: string;
  description_2: string;
  estimate_value: number;
  paid_value: number;
  claim_status: ClaimLandingStatus[] = [];
}




